<script lang="ts">
import { defineComponent, h, type PropType, toDisplayString } from 'vue';

import { CdsIcon } from '../CdsIcon';
import { makeIconProps, makeTitleProps, useRender } from '../../composable';

import CdsCardSubtitle from './CdsCardSubtitle.vue';
import CdsCardTitle from './CdsCardTitle.vue';

export const componentName = 'CdsCardItem';
export default defineComponent({
  name: componentName,
  props: {
    /**
     * Подзаголовок
     */
    subtitle: {
      type: [String] as PropType<string>,
      default: ''
    },
    ...makeTitleProps(),
    ...makeIconProps()
  },
  setup(props, { slots }) {
    useRender(() => {
      const hasTitle = !!slots.title || !!props.title;
      const hasSubtitle = !!slots.subtitle || !!props.subtitle;
      const hasPrepend = !!slots.prepend || !!props.prependIcon;
      const hasAppend = !!slots.append || !!props.appendIcon;

      return h(
        'div',
        {
          class: 'cds-card-item'
        },
        [
          hasPrepend &&
            h(
              'div',
              { key: 'prepend', class: 'cds-card-item__prepend' },
              !slots.prepend ? h(CdsIcon, { key: 'prepend-icon', name: props.prependIcon }) : slots.prepend()
            ),

          h('div', { class: 'cds-card-item__content' }, [
            hasTitle &&
              h(
                CdsCardTitle,
                { key: 'title' },
                {
                  default: () => slots.title?.() ?? toDisplayString(props.title)
                }
              ),

            hasSubtitle &&
              h(
                CdsCardSubtitle,
                { key: 'subtitle' },
                {
                  default: () => slots.subtitle?.() ?? toDisplayString(props.subtitle)
                }
              ),

            slots.default?.()
          ]),

          hasAppend &&
            h(
              'div',
              { key: 'append', class: 'cds-card-item__append' },
              !slots.append ? h(CdsIcon, { key: 'append-icon', name: props.appendIcon }) : slots.append()
            )
        ]
      );
    });

    return {};
  }
});
</script>
